// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreSearch = (client) => ({
    /**
     * `GET /store/search`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreSearchProducts
     * @source apps/backend/src/api/store/search/route.ts
     */
    list: (query, headers) => client.fetch("/store/search", { method: "GET", query, headers }),
});
//# sourceMappingURL=search.js.map